import StatsDashboard from '@/components/stats/StatsDashboard'

export default function StatsPage() {
  return <StatsDashboard />
}
